import { Flame, Gauge, Zap } from "lucide-react";
import { lazy } from "react";

import type { TabRoute } from "@/lib/routes";

// Lazy-loaded so opening one calculator does not pull the other two.
const CapacityCalculatorTab = lazy(() => import("./CapacityCalculatorTab"));
const TransmissionCalculatorTab = lazy(
  () => import("./TransmissionCalculatorTab"),
);
const EnbridgeCalculatorTab = lazy(() => import("./EnbridgeCalculatorTab"));

/**
 * Child tab routes for `/ses-calculators` (AB#8345).
 *
 * Declared here rather than inline in the route table so the parent page can
 * import the list without a circular import — the route table already
 * imports the parent page.
 *
 * Order follows the ticket, which names the three tabs in this sequence.
 * It is a deliberate reading order, not an alphabetical list.
 */
export const SES_CALCULATOR_TAB_ROUTES: ReadonlyArray<TabRoute> = [
  {
    path: "capacity",
    label: "Capacity Calculator",
    icon: Gauge,
    element: <CapacityCalculatorTab />,
  },
  {
    path: "transmission",
    label: "Transmission Calculator",
    icon: Zap,
    element: <TransmissionCalculatorTab />,
  },
  {
    path: "enbridge",
    label: "Enbridge Calculator",
    icon: Flame,
    element: <EnbridgeCalculatorTab />,
  },
];
